const MuSearchDesktop = () => {
    $("#nav-desktop-search").on("click", function () {
        setTimeout(function () {
            $(".nav-utility .dropdown-menu.show").css({"transform":"translate3d("+ 0 +"px, "+ 142 +"px, "+ 0 +"px)"});
        }, 10);
        setTimeout(function () {
            $("#desktop-search__input").trigger("focus");
        }, 100);
    });
}

export default MuSearchDesktop
